import {RESET_ENTITY} from '../actions'

export const defaultState = {
	isFetchingItem: false,
	isSavingItem: false,
	item: null,
	id: null
};

const entity = ({types, key}) => {
	if (!Array.isArray(types) || !(types.length === 3 || types.length === 6 || types.length === 9)) {
		throw new Error('Expected types to be an array of 3 or 6 or 9 elements.')
	}
	if (!types.every(t => typeof t === 'string')) {
		throw new Error('Expected types to be strings.')
	}

	const [requestType, successType, failureType, 
		requestSaveType, successSaveType, failureSaveType,
		requestDeleteType, successDeleteType, failureDeleteType] = types;

	const updateEntity = (state = defaultState, action) => {
		switch (action.type) {
			case requestType:
				return {
					...state,
					isFetchingItem: true
				};
			case successType:
				return {
					...state,
					isFetchingItem: false,
					item: action.response.data,
					id: action.response.data[key]
				};
			case failureType:
				return {
					...state,
					isFetchingItem: false,
					item: null
				};
			case requestSaveType:
				return {
					...state,
					isSavingItem: true
				};
			case successSaveType:
				return {
					...state,
					isSavingItem: false,
					item: action.response.data,
					id: action.response.data[key],
				};
			case failureSaveType:
				return {
				...state,
				isSavingItem: false
			};
			case requestDeleteType:
				return {
					...state,
					isSavingItem: true
				};
			case successDeleteType:
				return {
					...state,
					isSavingItem: false,
					item: {},
					id: action.response.data[key],
				};
			case failureDeleteType:
				return {
					...state,
					isSavingItem: false
				};
			default:
				return state
		}
	};

	return (state = {}, action) => {
		// Update entity by id
		switch (action.type) {
			case requestType:
			case successType:
			case failureType:
			case requestSaveType:
			case successSaveType:
			case failureSaveType:
			case requestDeleteType:
			case successDeleteType:
			case failureDeleteType:
				const idValue = action.id || (action.response && action.response.data ? action.response.data[key] : null);
				if (!idValue) {
					return {...state};
				}
				return {
					...state,
					[idValue]: updateEntity(state[idValue], action)
				};
			case RESET_ENTITY:
				if (!action.name || action.name === requestType) {
					return {}
				} else {
					return state
				}
			default:
				return state
		}
	}
};

export default entity



// WEBPACK FOOTER //
// ./src/reducers/entity.js